<template>
    <div class="container-fluid">
        <div class="row mb-2 align-items-center">
            <div :class="columnClass.title">
                <h1 class="my-2 text-dark">{{ title }}</h1>
            </div>
            <div class="col-12 col-sm-4 text-center pl-0" v-if="extraText">
                <h4 class="mt-2 text-secondary">{{ extraText }}</h4>
            </div>
            <div :class="columnClass.atras" v-if="atras">
                <Button type="button" name="button" class="my-2" @click.prevent="volver()" icon="fas fa-arrow-left">Atrás</Button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            extraText: String,
            atras: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {

            }
        },
        computed: {
            columnClass() {
                if (this.extraText) {
                    return {
                        title: 'col-12 col-sm-4',
                        atras: 'col-12 col-sm-4 text-sm-right'
                    }
                } else {
                    return {
                        title: 'col-12 col-sm-6',
                        atras: 'col-12 col-sm-6 order-sm-last text-sm-right'
                    }
                }
            }
        },
        methods: {
            volver() {
                this.$router.go(-1);
            }
        }
    }
</script>